var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("span", [
        _c(
          "button",
          {
            staticClass: "button is-ghost",
            on: {
              click: function ($event) {
                _vm.isImagesModalActive = true
              },
            },
          },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.images.length))]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("b-modal", {
        attrs: {
          "destroy-on-hide": false,
          "aria-role": "dialog",
          "close-button-aria-label": "Close",
          "aria-modal": "",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (props) {
              return [
                _c(
                  "ul",
                  _vm._l(_vm.images, function (image) {
                    return _c("li", { staticClass: "mb-5" }, [
                      _c("div", { staticClass: "card" }, [
                        _c(
                          "div",
                          { staticClass: "card-image" },
                          [
                            _c("fb-img", {
                              attrs: {
                                fileId: image.fileId,
                                mimeType: image.mimeType,
                                size: "raw",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        image.caption
                          ? _c("div", { staticClass: "card-content" }, [
                              _c("div", { staticClass: "media" }, [
                                _c("div", { staticClass: "media-content" }, [
                                  _vm._v(_vm._s(image.caption)),
                                ]),
                              ]),
                            ])
                          : _vm._e(),
                      ]),
                    ])
                  }),
                  0
                ),
              ]
            },
          },
        ]),
        model: {
          value: _vm.isImagesModalActive,
          callback: function ($$v) {
            _vm.isImagesModalActive = $$v
          },
          expression: "isImagesModalActive",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "fas fa-images" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }